"use client";


import {ReactNode, useEffect, useRef, useState} from "react";
import {Paginator} from "./Paginator";
import {useMounted} from "@restart/hooks";
import { Loadbar} from "../../contexts/useLoader";


type Props<T> = {
    items: T[],
    page: number,
    loader: (page: number) => Promise<{ pages: number, result: T[]}>
    pages: number,
    render: (t: T[]) => ReactNode,
    nextText: string,
    byClick?: boolean,
    hrefBuilder?:  (pageIndex: number,
                   pageCount: number,
                   selectedPage: number) => string

}



export function NextList<T>({items, byClick, pages, page, loader, render, nextText, hrefBuilder}: Props<T>) {

    const changed = useRef(0);
    const [loading, setLoading] = useState(false);

    const [initValues, setInitValues] = useState(() => {
        return {
            page: page || 1,
            items: items
        }
    })

    const mounted = useMounted();

    useEffect(() => {
        setInitValues({
            page: page || 1,
            items
        })
        changed.current += 1;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(items), page]);

    return <>
        <Loadbar loading={loading} />
        {render(initValues.items)}
        <div>
            {initValues.page  < pages ?
            <button className={`m-auto d-block btn btn-radiacz btn-next-list mt-24px mb-24px`} onClick={e => {
                e.preventDefault();

                const newPage = initValues.page + 1;

                const ch = changed.current;
                (async () => {

                    const promise = loader(newPage);
                    if (ch !== changed.current || !mounted()) {
                        return;
                    }

                    try {
                        setLoading(true);
                        const newResult = await promise
                        const newValue = {
                            page: newPage,
                            items: initValues.items.concat(newResult.result)
                        };
                        setInitValues(newValue);
                    } catch (e) {
                        console.error(e);
                    }
                    finally {
                        setLoading(false);
                    }
                })();
            }}>{nextText}
            </button>  : false}
            <Paginator byClick={byClick} hrefBuilder={hrefBuilder} pages={pages} initalPage={initValues.page}/>
        </div>
    </>
}